import React from "react";
import {BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';
import { connect } from "react-redux";
import ExpenseDashBoardPage from "../components/ExpenseDashBoardPage";
import AddExpensePage from "../components/AddExpensePage";
import EditExpensePage from "../components/EditExpensePage";
import Header from "../components/Header";
import NotFoundPage from "../components/NotFoundPage";
import LoginPage from "../components/LoginPage";

export const AppRouter = ({isAuthenticated}) => {

    return (
        <BrowserRouter>
            <Routes>
                <Route 
                    path='/' 
                    element={
                        isAuthenticated ? <Navigate replace to='/dashboard' /> : <LoginPage />
                    } 
                />
                <Route 
                    path='/dashboard' 
                    element={
                        isAuthenticated ?
                        <div>
                            <Header />
                            <ExpenseDashBoardPage />
                        </div> : <Navigate replace to='/' />
                    } 
                />
                <Route 
                    path='/add' 
                    element={
                        isAuthenticated ?
                        <div>
                            <Header />
                            <AddExpensePage />
                        </div> : <Navigate replace to='/' />
                    } 
                />
                <Route 
                    path='/edit/:id' 
                    element={
                        isAuthenticated ?
                        <div>
                            <Header />
                            <EditExpensePage />
                        </div> : <Navigate replace to='/' />
                    } 
                />
                <Route path='/*' element={<NotFoundPage />} />
            </Routes>      
        </BrowserRouter>
    );
};

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.auth.uid
});

export default connect(mapStateToProps)(AppRouter);